import type { FC } from "react";
import React from "react";

import { getServiceName } from "@core/domains/identity";

import { AppHeader } from "@react/foundation/app";
import { AppContainer, PageContainer } from "@react/web/app";

import { ACCOUNT_SERVICE } from "@apis/account/config";

import { HealthHistoryCompact } from "./features/health-history/index.ts";

export const App: FC = () => (
  <AppContainer>
    <AppHeader title="AptBlocks" />
    <PageContainer>
      <div className="flex flex-col gap-4">
        <HealthHistoryCompact
          name="Account Service"
          target={getServiceName(ACCOUNT_SERVICE.ID)}
        />
        <HealthHistoryCompact name="Database" target="database" />
      </div>
    </PageContainer>
  </AppContainer>
);
